<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()" :largebox="true">
      <div class="content" slot="content">
        <div class="flex end actions">
            <div class="button secondary" @click="openModalNew()">
              Importar Novo Arquivo
            </div>
        </div>
        <div class="flex end margin-top-s">
          Baixar exemplo de arquivo CSV para importação: <a :href="urlModel">Clique Aqui</a>
        </div>
        <ul class="margin-top-l">
          <li v-if="false">
            <small>
              Adicione sua primeira importação para começar a rodar suas campanha.
            </small>
          </li>
          <li v-for="(m, k) in imports" :key="k">
            <div class="flex middle">
              <div class="flex-2">
                <div class="flex start">
                  ({{ m.id }}) {{ m.file_name }}
                  <div class="tag">{{ m.status }}</div>
                </div>
              </div>
              <div class="flex-1 flex end">
                <div class="button secondary" @click="openModalDelete(m.id)">
                  Deletar
                </div>
              </div>
            </div>
          </li>
        </ul>

      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <a @click="closeModal()" class="button secondary medium">
            Fechar
          </a>
        </div>
      </div>
    </modal>
    <!-- new list -->
    <new-import
      :show="showEditModal"
      @close="
        showEditModal = false;
        newImport = null;
      "
      @accept="newOrEditList($event)"
    ></new-import>
    <!-- modal confirm delete -->
    <modal-confirm
      :show="showDeleteModal"
      description="Você tem certeza que deseja deletar essa importação?"
      @cancel="
        showDeleteModal = false;
        selectModalDelete = null;
      "
      @accept="removeImport(selectModalDelete)"
    ></modal-confirm>
  </section>
</template>

<script>
import { getImports, createImport, removeImport } from "@/services/imports";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";
import NewImport from "./NewImport";

const auxNewImport = {
  name: ''
}

export default {
  name: "modal-imports",
  props: {
    titleName: {
      required: false,
      default: "Importações",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
    tag: {
      required: true,
      default: Object,
    },
  },
  components: {
    Modal,
    ModalConfirm,
    NewImport,
  },
  data() {
    return {
      showDeleteModal: false,
      selectModalDelete: null,
      newImport: null,
      showEditModal: false,
      showModal: false,
      seenGuide: {},
      title: "Importações",
      imports: [],
      typeList: [
        { id: "TEXT", label: "TEXT" },
        { id: "AWAIT", label: "AWAIT" },
        { id: "IMG", label: "IMG" },
        { id: "LINK", label: "LINK" },
      ],
      timeList: [
        { id: "10MIN", label: "10MIN" },
        { id: "30MIN", label: "30MIN" },
        { id: "60MIN", label: "60MIN" },
        { id: "24H", label: "24H" },
        { id: "48H", label: "48H" },
        { id: "72H", label: "72H" },
      ],
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  mounted() {
    this.getImports();
  },
  computed: {
    isEdit() {
      return this.tag && this.tag.id;
    },
    urlModel() {
      return `${window.location.origin}/admin/static/sample/import-contacts.csv`
    },
  },
  methods: {
    newOrEditList(auxList) {
      this.showEditModal = false
      this.newImport = null

      return this.createImport(auxList)
    },
    openModalEdit(listAux) {
      this.showEditModal = true
      this.newImport = listAux
    },
    openModalNew() {
      this.showEditModal = true
      this.newImport = Object.assign({}, auxNewImport)
    },
    openModalDelete(importId) {
      this.showDeleteModal = true
      this.selectModalDelete = importId
    },
    getImports() {
      getImports()
        .then((result) => {
          this.imports = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "falha ao buscar listas",
          });
        });
    },
    createImport(import_params) {

      let params = {
        importType: 'csv',
        contet: 'contact',
        tmpFileName: import_params.file_name
      }

      createImport(params)
        .then((result) => {
          this.imports.push(result);
          this.$toast.success({
            title: "Sucesso",
            message: "Importação criada com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao criar Importação",
          });
        });
    },
    removeImport(import_id) {
      removeImport(import_id)
        .then(() => {

          this.imports = this.imports.filter(l => l.id != import_id)
          this.$toast.success({
            title: "Sucesso",
            message: "Lista removida com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao remover lista",
          });
        })
        .finally(() => {
          this.showDeleteModal = false
          this.selectModalDelete = null
        })
    },
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", this.tag);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>


.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

ul {
  list-style: none;
  max-height: 350px;
  overflow-y: scroll;
  li {
    padding: 4px 8px;
    border-bottom: 1px solid #ccc;
    .tag {
      background: #c2c2c2;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 11px;
      font-weight: 800;
      margin-left: 8px;
    }
    .button {
      margin-left: 4px;
      padding: 4px 6px;
    }
  }
}
</style>
